import React, { useState, useEffect,useRef } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";

export const AthleteStaticSpeedWorkoutTemplateList = () => {
  const { athlete } = useAthleteAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [templates, setTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState(null); // Error state
  const [selectedDate, setSelectedDate] = useState(new Date()); // State for selected date


// Function to fetch templates from the server
const fetchTemplatesData = async () => {
  try {
    setIsLoading(true); // Start loading
    console.log("Fetching templates...");

    const response = await fetch(API_URL.FRONTEND_ATHLETE_PURCHASED_SPEED_PRODUCTS + athlete.id, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${athlete.token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      setError(errorData?.error || "Failed to fetch templates data");
      return;
    }

    const data = await response.json();
    console.log(data);


    //setTemplates(data || []); // Set the fetched templates
  } catch (err) {
    setError(err.message); // Set error if any issue occurs during the fetch
  } finally {
    setIsLoading(false); // End loading
  }
};

 // useEffect for checking location.state and fetching data if necessary
 useEffect(() => {
  console.log("Old State Data");
  console.log(location.state?.templates);

  // Check if templates exist in location.state
  if (location.state?.templates && location.state.templates.length > 0) {
    // If templates are in location.state, populate them
    setTemplates(location.state.templates);
  } else if (templates.length === 0) {
    // If templates are empty and not in state, fetch them from API
    fetchTemplatesData();
  }
}, [location.state, templates.length, athlete.token, athlete.id]);

  // Function to handle date change
  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  // Format the date for display
  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const handleStaticWarmupRoutineClick = () => {
    navigate('');
  }

  return (
    <AthleteLayout>
      <div className="bg-white">
        <AthleteHeader />
      </div>
      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">{formatDate(selectedDate)}</p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="w-full max-w-2xl mx-auto h-full bg-black">
        <div className="text-white py-3 bg-black">
          <div className="flex justify-between gap-[68px] mb-4 px-5">        
            <button className="text-white border-b-2 border-white text-base pb-2 font-normal">
              Static Speed Templates
            </button>
          </div>

          {isLoading ? (
            <p className="text-white text-center">Loading templates...</p>
          ) : error ? (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">{error}</div>
          ) : (
            <div className="space-y-[15px] overflow-hidden overflow-y-auto px-5">
              {templates &&
                templates.map((item) => (
                  <button
                    onClick={() => navigate('/athlete/static-warmup-routine/phase/' + item.warmup_routine_id + "/" + item.template_id, { state: { templates } })}
                    key={item.template_id}
                    className="w-full p-[14px] text-white font-normal border border-white/20 bg-transparent rounded-[15px] hover:bg-white/10 transition text-start"
                  >
                    {item.title} {/* Display label here */}
                  </button>
                ))}
            </div>
          )}
        </div>
      </div>
    </AthleteLayout>
  );
};

const ArrowG = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowL = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
